import React from "react";
import logo from "./images/logo-square-white.png";

const now = new Date();
const linkStyle = "f6 link white-80";

const Footer = () => (
  <footer
    className="mt2 pa4 white bt bw2"
    style={{ backgroundColor: "#32a6b4", borderColor: "#0f4750" }}
  >
    <div className="mw7 center">
      <div className="fr fl-ns w-40 w-20-ns dib">
        <a href="https://www.o3powered.com/?ref=churncalculator">
          <img src={logo} alt="Perspexi Labs" className="mw-100" />
        </a>
      </div>

      <div className="fl w-20-ns mh5-ns fw3 pl2-l">
        <span className="f6 ttu fw5 mb1 dib tracked">Learn More</span>
        <ul className="list pl0">
          <li className="mb1">
            <a
              href="https://www.o3powered.com/outreach/features/"
              className={linkStyle}
            >
              • Use O3 to improve customer churn
            </a>
          </li>
          <li className="mb1">
            <a href="https://www.o3powered.com/blog/" className={linkStyle}>
              • Read more on our blog
            </a>
          </li>
          <li className="mb1">
            <a href="https://www.o3powered.com/contact/" className={linkStyle}>
              • Contact Us
            </a>
          </li>
        </ul>
      </div>

      <div className="fl w-40-ns pt2 pt0-ns">
        <span className="f6 ttu fw5 mb1 dib tracked">About O3</span>
        <p className="f6 lh-copy white-80">
          O3 helps businesses tap into what their customers really think and
          give a voice to customers that they&apos;ve never had before,
          re-establishing those one-on-one relationships.
        </p>
        <p className="f6 lh-copy white-80">
          We believe that the key to better business is better, truly human
          relationships and that when used correctly technology can help.
        </p>
      </div>

      <div className="cl pt3">
        <p className="tc f6 fw1">
          © {now.getFullYear()} - O3 Powered, a Blue Star Services, LLC company
        </p>
        <p className="tc f6 fw1">
          <a
            href="https://www.o3powered.com/privacy-policy/"
            className={linkStyle}
          >
            Privacy Policy
          </a>{" "}
          |{" "}
          <a
            href="https://www.o3powered.com/terms-of-service/"
            className={linkStyle}
          >
            Terms of Service
          </a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js